var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "layout-base",
    { attrs: { title: _vm.$t("STEP_TWO.TITLE") } },
    [
      _c(
        "template",
        { slot: "content" },
        [
          _c("bk-select", {
            staticClass: "select",
            attrs: {
              fields: _vm.countryList,
              value: _vm.country,
              label: _vm.$t("STEP_TWO.COUNTRY"),
              id: "country-select",
              valid: true,
              pristine: false
            },
            on: { input: _vm.changeCountry }
          }),
          _vm._v(" "),
          _c("bk-place", {
            attrs: {
              label: _vm.$t("STEP_TWO.ZIP_OR_PLACE"),
              "helper-text": _vm.$t("STEP_TWO.COUNTRY_HELPER_TEXT"),
              country: _vm.country,
              initialCity: _vm.city,
              initialGeoId: _vm.geoId,
              valid: _vm.geoIdValid,
              id: "placesearch",
              "allow-hotjar-recording": true
            },
            on: { change: _vm.changePlace }
          }),
          _vm._v(" "),
          _c("bk-birthdate", {
            attrs: { birthdate: _vm.birthdate, valid: _vm.birthdateValid },
            on: { change: _vm.changeBirthdate }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "buttons" },
        [
          _c(
            "bk-button",
            {
              attrs: {
                disabled:
                  _vm.country.isEmpty() ||
                  !_vm.geoIdValid ||
                  !_vm.birthdateValid
              },
              on: { click: _vm.navigate }
            },
            [_vm._v(_vm._s(_vm.$t("GLOBAL.CONTINUE")) + "\n  ")]
          ),
          _vm._v(" "),
          _c("bk-back-button", {
            attrs: {
              "track-action": "Schritt2",
              "track-label": "Zurueck",
              to: "/"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "usp" },
        [!_vm.coupon.isEmpty() ? _c("coupon-box") : _vm._e()],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }